<div class="label-container" #labelContainerEl>
  <ng-content select="[label]"></ng-content>
  <!-- <span *ngIf="required" class="required-indicator">*</span> -->
</div>
<div class="field-container">
  <ng-content select="[field]"></ng-content>

  <div class="field-suffix" *ngIf="_suffixChildren.length">
    <ng-content select="[appFieldSuffix]"></ng-content>
  </div>
</div>
